// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "87a27d97" + "." + "aa2211df319e1bb7" + ".js";
};